import {
	BulbOutlined,
	CommentOutlined,
	ExclamationCircleOutlined,
	FileTextOutlined,
	KeyOutlined,
	PlayCircleOutlined,
	QuestionCircleOutlined,
	ReadOutlined,
	TagOutlined,
	UserOutlined,
} from '@ant-design/icons';
import { Flex, Segmented } from 'antd';

export const titles = {
	'key-insights': 'Summary',
	'creator-insight': 'Creator information',
	'video-insight': 'Video insights',
	'brand-mentions': 'Brand mentions',
	'entity-insights': 'Entity insights',
	transcript: 'Transcription',
	comments: 'Top comments',
	actions: 'Actions',
	'brands-entities': 'Subjects and References',
	topics: 'Topics',
	history: 'Video Analysis History',
	collections: 'Collections',
	'questions-answers': 'Q&A - chat with the video',
	undefined: '',
};

export type TTitle = keyof typeof titles;

export const tabOptions = [
	{
		value: 'key-insights',
		icon: BulbOutlined,
		title: 'Summary',
		// chunk: "Summary",
		chunk: ['Summary', 'Insights'],
	},
	{
		value: 'transcript',
		icon: FileTextOutlined,
		title: 'Transcription',
		chunk: 'transcription',
	},
	{
		value: 'creator-insight',
		icon: UserOutlined,
		title: 'Creator information',
		chunk: 'creator',
	},
	{
		value: 'video-insight',
		icon: PlayCircleOutlined,
		title: 'Video insights',
		chunk: 'video',
	},
	{
		value: 'comments',
		icon: CommentOutlined,
		title: 'Comments',
		chunk: 'comments',
	},
	// {
	// 	value: 'actions',
	// 	icon: ExclamationCircleOutlined,
	// 	title: 'Actions',
	// 	// chunk: "ViewerActions",

	// 	chunk: ['ViewerActions', 'EntityActions', 'ControversialTopics'],
	// },
	{
		value: 'brands-entities',
		icon: TagOutlined,
		title: 'Subjects and References',
		chunk: 'Entities',
	},
	{
		value: 'questions-answers',
		icon: QuestionCircleOutlined,
		title: 'Q&A - chat with the video',
		chunk: [],
	},
	{
		value: 'prompts-evaluation',
		icon: QuestionCircleOutlined,
		title: 'Prompts Evaluation',
		chunk: 'Prompts',
	},
	// {
	// 	value: 'topics',
	// 	icon: ReadOutlined,
	// 	title: 'Topics',
	// 	chunk: 'Topics',
	// },
];

type TProps = {
	className?: string;
	activeMenuTab?: string;
	setActiveMenuTab: any;
	isForContentMonitor?: boolean;
};

export default function TabsControls({
	className = '',
	setActiveMenuTab,
	activeMenuTab = 'transcript',
	isForContentMonitor = false,
}: TProps) {
	const options = isForContentMonitor
		? tabOptions.filter(
				(item) =>
					item.value !== 'questions-answers' &&
					item.value !== 'topics' &&
					item.value !== 'key-insights' &&
					item.value !== 'comments',
		  )
		: tabOptions.filter((item) => item.value !== 'prompts-evaluation');

	return (
		<Flex
			justify="space-between"
			style={{ width: '100%', paddingBottom: '0.5rem' }}
			className={className}
		>
			<Segmented
				value={activeMenuTab}
				onChange={(value) => {
					setActiveMenuTab(value);
				}}
				options={options.map((item) => {
					const Icon = item.icon;
					return { ...item, icon: <Icon /> };
				})}
			/>
		</Flex>
	);
}
